import { render, staticRenderFns } from "./QuoteSidebar.vue?vue&type=template&id=688ce96c&scoped=true"
import script from "./QuoteSidebar.vue?vue&type=script&lang=js"
export * from "./QuoteSidebar.vue?vue&type=script&lang=js"
import style0 from "./QuoteSidebar.vue?vue&type=style&index=0&id=688ce96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ce96c",
  null
  
)

export default component.exports